import React from 'react';
import Dropzone from 'dropzone';
import { IMG_URL } from '../../constants/files';

// Store File objects outside of Redux state
const fileStore = {};

class DropzoneReduxForm extends React.Component {
  constructor(props) {
    super(props);
    // Generate a unique ID for this instance
    this.instanceId = `dropzone_${Date.now()}_${Math.random()
      .toString(36)
      .substr(2, 9)}`;
  }

  componentDidMount() {
    const {
      input: { onChange, name },
    } = this.props;
    const dzId = this.instanceId;
    let currentSingleFile = undefined;

    new Dropzone(document.getElementById(`dropzone-single-${dzId}`), {
      url: '/',
      autoProcessQueue: false, // Prevent auto-upload
      uploadMultiple: false,
      thumbnailWidth: null,
      thumbnailHeight: null,
      previewsContainer: document.getElementById(`dz-preview-single-${dzId}`),
      previewTemplate: document.getElementById(`dz-preview-single-${dzId}`)
        .innerHTML,
      maxFiles: 1,
      acceptedFiles: 'image/*',
      init: function() {
        this.on('addedfile', function(file) {
          if (currentSingleFile) {
            this.removeFile(currentSingleFile);
          }
          currentSingleFile = file;

          // Store the actual File object in our external store
          fileStore[name] = file;

          // Pass a reference to Redux Form (just the filename)
          onChange({
            name: file.name,
            __isFileReference: true,
            __fieldName: name,
          });
        });
      },
    });
  }

  componentWillUnmount() {
    // Clean up the file store when component unmounts
    const {
      input: { name },
    } = this.props;
    delete fileStore[name];
  }

  render() {
    const {
      input: { value },
      containerClassName = '',
    } = this.props;
    const dzId = this.instanceId;

    // Check if value is a string (existing image path) or an object (new file reference)
    const hasValue =
      value && (typeof value === 'string' || value.__isFileReference);
    const imagePath = typeof value === 'string' ? value : '';

    return (
      <>
        <div
          className={`dropzone-custom dropzone dropzone-single ${
            hasValue ? 'dz-clickable dz-max-files-reached' : ''
          } ${containerClassName}`}
          id={`dropzone-single-${dzId}`}
        >
          <div className="fallback">
            <div className="custom-file">
              <input
                className="custom-file-input"
                id={`input-upload-${dzId}`}
                type="file"
              />
              <label
                className="custom-file-label"
                htmlFor={`input-upload-${dzId}`}
              >
                Choose file
              </label>
            </div>
          </div>
          <div
            id={`dz-preview-single-${dzId}`}
            className="bg-translucent-secondary dz-preview"
          >
            <div className="dz-preview-cover">
              <img
                alt="..."
                className="dz-preview-img"
                data-dz-thumbnail=""
                src={imagePath ? `${IMG_URL}${imagePath}` : ''}
              />
            </div>
            <div className="dz-preview-cover dz-processing dz-error dz-complete dz-image-preview">
              <img
                alt="..."
                className="dz-preview-img"
                data-dz-thumbnail=""
                src={imagePath ? `${IMG_URL}${imagePath}` : ''}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

// Helper function to get the actual File object
export const getFileFromStore = fieldName => {
  return fileStore[fieldName];
};

// Helper function to process form values and replace file references with actual Files
export const processFormWithFiles = formValues => {
  const processed = { ...formValues };

  // Check if img field is a file reference
  if (processed.img && processed.img.__isFileReference) {
    const actualFile = fileStore[processed.img.__fieldName];
    if (actualFile) {
      processed.img = actualFile;
    }
  }

  return processed;
};

export default DropzoneReduxForm;
